import { Controller } from "@hotwired/stimulus"

// Disables a native (data-turbo="false") form's submit buttons once submission
// starts. Turbo normally handles this, but it ignores opted-out forms — like
// the sign-in page's OmniAuth forms, where a double-click submits the request
// phase twice, overwrites the stored OAuth state, and fails the callback's
// CSRF check. Disabling also flips the buttons' show-when-disabled loading
// label. Re-enables on pageshow so a bfcache restore (back button from the
// SSO provider) doesn't leave a dead button.
export default class extends Controller {
  connect() {
    window.addEventListener("pageshow", this.enable)
  }

  disconnect() {
    window.removeEventListener("pageshow", this.enable)
  }

  // Runs on submit, after submission has already started, so disabling here
  // doesn't block the form — only re-clicks.
  disable() {
    this.#buttons.forEach((button) => (button.disabled = true))
  }

  enable = () => {
    this.#buttons.forEach((button) => (button.disabled = false))
  }

  get #buttons() {
    return this.element.querySelectorAll("button")
  }
}
